import React from 'react';
import { Grid, TextField, Stack, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { formatCurrency } from '../../../utils/formatters';

const SaleFormSummary = ({
    satisNotlari,
    setSatisNotlari,
    toplamTutar,
    odenenTutar,
    setOdenenTutar,
    odemeTipi,
    setOdemeTipi
}) => {
    return (
        <Grid container spacing={3} sx={{ mt: 1 }}>
            <Grid item xs={12} md={6}>
                <TextField
                    label="Satış Notları"
                    multiline
                    rows={4}
                    fullWidth
                    value={satisNotlari}
                    onChange={e => setSatisNotlari(e.target.value)}
                />
            </Grid>
            <Grid item xs={12} md={6}>
                <Stack spacing={2}>
                    <TextField
                        label="Toplam Tutar"
                        value={formatCurrency(toplamTutar || 0)}
                        fullWidth
                        InputProps={{ readOnly: true }}
                    />
                    <TextField
                        label="Ödenen Tutar (₺)"
                        type="number"
                        value={odenenTutar}
                        onChange={e => setOdenenTutar(Number(e.target.value))}
                    />
                    <TextField
                        label="Kalan Tutar"
                        value={formatCurrency((toplamTutar || 0) - (odenenTutar || 0))}
                        fullWidth
                        InputProps={{ readOnly: true }}
                    />
                    <FormControl fullWidth>
                        <InputLabel>Ödeme Tipi</InputLabel>
                        <Select
                            value={odemeTipi}
                            label="Ödeme Tipi"
                            onChange={e => setOdemeTipi(e.target.value)}
                        >
                            <MenuItem value="Nakit">Nakit</MenuItem>
                            <MenuItem value="Kredi Kartı">Kredi Kartı</MenuItem>
                            <MenuItem value="Havale/EFT">Havale/EFT</MenuItem>
                        </Select>
                    </FormControl>
                </Stack>
            </Grid>
        </Grid>
    );
};

export default SaleFormSummary;
